import React from 'react';

const technicalSeoItems = [
  {
    title: 'Website Speed:',
    desc: 'Important to deliver a smooth user experience and improve search engine rankings.'
  },
  {
    title: 'Mobile Friendliness:',
    desc: 'Offer a better user experience on phones. It helps in longer visit durations and better engagement.'
  },
  {
    title: 'Website UI/UX:',
    desc: 'Website UI/UX or a good web design contributes to brand credibility and increases website traffic through intuitive design and user friendly navigation.'
  },
  {
    title: 'Crawling:',
    desc: 'Allows search engines to discover and analyze your website content. It helps for proper indexing in search results.'
  },
  {
    title: 'HTTPS:',
    desc: 'They safeguard user information and demonstrate the security and reliability of your website.'
  },
  {
    title: 'Breadcrumbs:',
    desc: 'Help users navigate your website easily by showing their location within the site structure.'
  },
  {
    title: 'URL Structure:',
    desc: 'Makes it easier for both users and search engines to understand what a web page is about.'
  },
  {
    title: 'Robots.txt File:',
    desc: 'Guides search engine bots on which parts of your website should be indexed or ignored.'
  },
  {
    title: 'Structured Data Markup:',
    desc: 'Provides additional context to search engines, helping them interpret and display your content more effectively.'
  },
  {
    title: 'Canonical:',
    desc: 'Indicates the original source of content, helping to avoid duplicate content issues and maintain SEO value.'
  },

];

function TechnicalSeoScrollSection() {
  return (
    <section className="technical-seo-scroll-section">
      <div className="container technical-seo-container">
        {/* Left Column: Scrollable Technical SEO Content */}
        <div className="technical-seo-left">
          <h2 className="technical-seo-title">Technical SEO</h2>

          <div className="technical-seo-scroll-box">
            {technicalSeoItems.map((item, index) => (
              <div key={index} className="technical-seo-item">
                <h3 className="technical-seo-item-title">{item.title}</h3>
                <p className="technical-seo-item-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right Column: Image Showcase */}
        <div className="technical-seo-right">
          <div className="technical-seo-img-wrapper">
            <img
              src="/assets/images/seo-services/seo-img2.jpg"
              alt="Technical SEO Architecture and Search Optimization"
              className="technical-seo-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default TechnicalSeoScrollSection;
